import { createNumericRange } from "../shared/numeric-range";
export const KNOB_START_ANGLE = 120;
export const KNOB_ARC_ANGLE = 300;
export const KNOB_DEFAULT_STROKE_WIDTH = 14;
const KNOB_GAP_MIDPOINT = KNOB_ARC_ANGLE + (360 - KNOB_ARC_ANGLE) / 2;
export function resolveKnobStrokeWidth(strokeWidth) {
  return Math.min(100, Math.max(0, Number.isFinite(strokeWidth) ? Number(strokeWidth) : KNOB_DEFAULT_STROKE_WIDTH));
}
export function formatKnobValue(value, step, template) {
  return template.replace("{value}", value.toFixed(step < 1 ? 2 : 0));
}
export function createKnobRing(value, min, max, step, strokeWidth, valueTemplate) {
  const range = createNumericRange(min, max, step);
  const resolvedStrokeWidth = resolveKnobStrokeWidth(strokeWidth);
  const radius = 50 - resolvedStrokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const arcLength = KNOB_ARC_ANGLE / 360 * circumference;
  const clamped = range.clamp(value);
  return {
    startAngle: KNOB_START_ANGLE,
    strokeWidth: resolvedStrokeWidth,
    radius,
    circumference,
    arcLength,
    progressLength: range.ratioFor(clamped) * arcLength,
    valueText: formatKnobValue(clamped, range.step, valueTemplate)
  };
}
export function knobValueFromPointer(clientX, clientY, rect, range) {
  if (rect.width === 0 || rect.height === 0) {
    return null;
  }
  const pointerAngle = Math.atan2(clientY - (rect.top + rect.height / 2), clientX - (rect.left + rect.width / 2)) * 180 / Math.PI;
  const alongArc = (pointerAngle - KNOB_START_ANGLE + 360) % 360;
  const clampedAlong = alongArc <= KNOB_ARC_ANGLE ? alongArc : alongArc <= KNOB_GAP_MIDPOINT ? KNOB_ARC_ANGLE : 0;
  return range.valueFromRatio(clampedAlong / KNOB_ARC_ANGLE);
}